import { NgClass } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

@Component({
    selector: "app-level-up-feed-animation",
    templateUrl: "./level-up-feed-animation.component.html",
    styleUrls: ["./level-up-feed-animation.component.css"],
    standalone: true,
    imports: [LottieComponent, NgClass],
})
export class LevelUpFeedAnimationComponent implements OnInit {
  options: AnimationOptions = {
    path: "assets/Rocket-animation.json",
  };

  public startAnimation = false;

  public imageLoadFailed = false;
  
  public defaultBackgroundSet = true;

  private timer = 5000;

  constructor(private dialogRef: MatDialogRef<LevelUpFeedAnimationComponent>) {}

  // This method close the dialog box
  closeDialog() {
    try {
      this.dialogRef.close();
    } catch (e) {
      return e;
    }
  }

  ngOnInit(): void {
    const backgroundImage = new Image();
    backgroundImage.src = "https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fbg_200x200.webp?alt=media";
    backgroundImage.onload = () => {
      this.startAnimation = true;
      this.imageLoadFailed = false;
      this.defaultBackgroundSet = false;
    };

    backgroundImage.onerror = () => {
      this.startAnimation = true;
      this.imageLoadFailed = true;
      this.defaultBackgroundSet = false;
    };
  }

  public onLoopComplete() {
    setTimeout(() => {
      this.closeDialog();
    }, this.timer);
  }
}
